// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomePhilosophyPage — "Trusted by people who take AI seriously"
   Prefix: impac_phiso_ho_pg_ · no :root variables · no green
   ============================================================ */

.impac_phiso_ho_pg_section {
  width: 100%;
  padding: 72px 0 80px;
  background: linear-gradient(180deg, #fbf9ff 0%, #f6f2ff 100%);
  font-family: "Manrope", "Roboto", sans-serif;
  overflow: hidden;
}

.impac_phiso_ho_pg_container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 24px;
}

/* ---------- Heading ---------- */

.impac_phiso_ho_pg_heading {
  margin: 0 0 36px;
  text-align: center;
  font-size: clamp(24px, 3vw, 34px);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: #0f0a2a;
  text-wrap: balance;
  opacity: 0;
  transform: translateY(22px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
}

/* ---------- Card ---------- */

.impac_phiso_ho_pg_card {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0;
  padding: 24px 12px;
  border-radius: 22px;
  background: #ffffff;
  box-shadow: 0 18px 50px rgba(74, 26, 158, 0.12), 0 2px 6px rgba(74, 26, 158, 0.05);
  opacity: 0;
  transform: translateY(34px) scale(0.98);
  transition:
    opacity 0.8s ease 0.1s,
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.1s;
}

/* ---------- Single stat ---------- */

.impac_phiso_ho_pg_stat {
  display: flex;
  align-items: stretch;
  gap: 14px;
  padding: 4px 22px;
  min-width: 0;
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 0.7s ease var(--d, 0ms),
    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

.impac_phiso_ho_pg_bar {
  flex-shrink: 0;
  width: 6px;
  border-radius: 6px;
  background: linear-gradient(180deg, #ffbf1f 0%, #f29900 100%);
  transform: scaleY(0);
  transform-origin: top center;
  transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--d, 0ms) + 150ms);
}

.impac_phiso_ho_pg_text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.impac_phiso_ho_pg_number {
  display: block;
  font-size: clamp(34px, 3.6vw, 46px);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.01em;
  color: #4a1a9e;
  font-variant-numeric: tabular-nums;
  min-height: 1.1em;
}

.impac_phiso_ho_pg_label {
  margin: 6px 0 0;
  font-size: 14.5px;
  line-height: 1.5;
  color: #6b6784;
  text-align: left;
}

/* ---------- Entrance: triggered when the section scrolls into view ---------- */

.impac_phiso_ho_pg_in .impac_phiso_ho_pg_heading,
.impac_phiso_ho_pg_in .impac_phiso_ho_pg_card,
.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat {
  opacity: 1;
  transform: none;
}

.impac_phiso_ho_pg_in .impac_phiso_ho_pg_bar {
  transform: scaleY(1);
}

/* hover: lift the stat and make the bar glow */
.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat:hover .impac_phiso_ho_pg_bar {
  box-shadow: 0 0 14px rgba(242, 153, 0, 0.55);
}

.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat:hover .impac_phiso_ho_pg_number {
  color: #3b003d;
}

.impac_phiso_ho_pg_number {
  transition: color 0.3s ease;
}

/* ============================================================
   Responsive — 1100 / 820 / 560
   ============================================================ */

@media (max-width: 1100px) {
  .impac_phiso_ho_pg_section {
    padding: 60px 0 68px;
  }

  .impac_phiso_ho_pg_stat {
    padding: 4px 14px;
    gap: 12px;
  }

  .impac_phiso_ho_pg_label {
    font-size: 13.5px;
  }
}

/* two by two */
@media (max-width: 820px) {
  .impac_phiso_ho_pg_section {
    padding: 52px 0 60px;
  }

  .impac_phiso_ho_pg_card {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 28px;
    padding: 26px 14px;
  }

  .impac_phiso_ho_pg_stat {
    padding: 4px 16px;
  }
}

/* single column */
@media (max-width: 560px) {
  .impac_phiso_ho_pg_section {
    padding: 44px 0 52px;
  }

  .impac_phiso_ho_pg_container {
    padding: 0 16px;
  }

  .impac_phiso_ho_pg_heading {
    margin-bottom: 26px;
  }

  .impac_phiso_ho_pg_card {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 24px;
    padding: 24px 10px;
    border-radius: 18px;
  }

  .impac_phiso_ho_pg_stat {
    padding: 2px 14px;
  }

  .impac_phiso_ho_pg_label {
    font-size: 14px;
  }
}

/* ---------- Reduced motion ---------- */

@media (prefers-reduced-motion: reduce) {
  .impac_phiso_ho_pg_heading,
  .impac_phiso_ho_pg_card,
  .impac_phiso_ho_pg_stat,
  .impac_phiso_ho_pg_bar {
    transition: opacity 0.2s ease !important;
    transition-delay: 0s !important;
    transform: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomePhilosophyPage/HomePhilosophyPage.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,WAAW;EACX,oBAAoB;EACpB,6DAA6D;EAC7D,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,4EAA4E;AAC9E;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,gDAAgD;EAChD,MAAM;EACN,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kFAAkF;EAClF,UAAU;EACV,uCAAuC;EACvC;;sDAEoD;AACtD;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B;;+DAE6D;AAC/D;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,6DAA6D;EAC7D,oBAAoB;EACpB,4BAA4B;EAC5B,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iFAAiF;;AAEjF;;;EAGE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,+CAA+C;AAC/C;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;IAChD,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;;AAEzC;EACE;;;;IAIE,wCAAwC;IACxC,+BAA+B;IAC/B,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   HomePhilosophyPage — \"Trusted by people who take AI seriously\"\n   Prefix: impac_phiso_ho_pg_ · no :root variables · no green\n   ============================================================ */\n\n.impac_phiso_ho_pg_section {\n  width: 100%;\n  padding: 72px 0 80px;\n  background: linear-gradient(180deg, #fbf9ff 0%, #f6f2ff 100%);\n  font-family: \"Manrope\", \"Roboto\", sans-serif;\n  overflow: hidden;\n}\n\n.impac_phiso_ho_pg_container {\n  max-width: 1240px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ---------- Heading ---------- */\n\n.impac_phiso_ho_pg_heading {\n  margin: 0 0 36px;\n  text-align: center;\n  font-size: clamp(24px, 3vw, 34px);\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n  color: #0f0a2a;\n  text-wrap: balance;\n  opacity: 0;\n  transform: translateY(22px);\n  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* ---------- Card ---------- */\n\n.impac_phiso_ho_pg_card {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0;\n  padding: 24px 12px;\n  border-radius: 22px;\n  background: #ffffff;\n  box-shadow: 0 18px 50px rgba(74, 26, 158, 0.12), 0 2px 6px rgba(74, 26, 158, 0.05);\n  opacity: 0;\n  transform: translateY(34px) scale(0.98);\n  transition:\n    opacity 0.8s ease 0.1s,\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.1s;\n}\n\n/* ---------- Single stat ---------- */\n\n.impac_phiso_ho_pg_stat {\n  display: flex;\n  align-items: stretch;\n  gap: 14px;\n  padding: 4px 22px;\n  min-width: 0;\n  opacity: 0;\n  transform: translateY(20px);\n  transition:\n    opacity 0.7s ease var(--d, 0ms),\n    transform 0.8s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n.impac_phiso_ho_pg_bar {\n  flex-shrink: 0;\n  width: 6px;\n  border-radius: 6px;\n  background: linear-gradient(180deg, #ffbf1f 0%, #f29900 100%);\n  transform: scaleY(0);\n  transform-origin: top center;\n  transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) calc(var(--d, 0ms) + 150ms);\n}\n\n.impac_phiso_ho_pg_text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.impac_phiso_ho_pg_number {\n  display: block;\n  font-size: clamp(34px, 3.6vw, 46px);\n  font-weight: 800;\n  line-height: 1.1;\n  letter-spacing: -0.01em;\n  color: #4a1a9e;\n  font-variant-numeric: tabular-nums;\n  min-height: 1.1em;\n}\n\n.impac_phiso_ho_pg_label {\n  margin: 6px 0 0;\n  font-size: 14.5px;\n  line-height: 1.5;\n  color: #6b6784;\n  text-align: left;\n}\n\n/* ---------- Entrance: triggered when the section scrolls into view ---------- */\n\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_heading,\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_card,\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat {\n  opacity: 1;\n  transform: none;\n}\n\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_bar {\n  transform: scaleY(1);\n}\n\n/* hover: lift the stat and make the bar glow */\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat:hover .impac_phiso_ho_pg_bar {\n  box-shadow: 0 0 14px rgba(242, 153, 0, 0.55);\n}\n\n.impac_phiso_ho_pg_in .impac_phiso_ho_pg_stat:hover .impac_phiso_ho_pg_number {\n  color: #3b003d;\n}\n\n.impac_phiso_ho_pg_number {\n  transition: color 0.3s ease;\n}\n\n/* ============================================================\n   Responsive — 1100 / 820 / 560\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .impac_phiso_ho_pg_section {\n    padding: 60px 0 68px;\n  }\n\n  .impac_phiso_ho_pg_stat {\n    padding: 4px 14px;\n    gap: 12px;\n  }\n\n  .impac_phiso_ho_pg_label {\n    font-size: 13.5px;\n  }\n}\n\n/* two by two */\n@media (max-width: 820px) {\n  .impac_phiso_ho_pg_section {\n    padding: 52px 0 60px;\n  }\n\n  .impac_phiso_ho_pg_card {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 28px;\n    padding: 26px 14px;\n  }\n\n  .impac_phiso_ho_pg_stat {\n    padding: 4px 16px;\n  }\n}\n\n/* single column */\n@media (max-width: 560px) {\n  .impac_phiso_ho_pg_section {\n    padding: 44px 0 52px;\n  }\n\n  .impac_phiso_ho_pg_container {\n    padding: 0 16px;\n  }\n\n  .impac_phiso_ho_pg_heading {\n    margin-bottom: 26px;\n  }\n\n  .impac_phiso_ho_pg_card {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 24px;\n    padding: 24px 10px;\n    border-radius: 18px;\n  }\n\n  .impac_phiso_ho_pg_stat {\n    padding: 2px 14px;\n  }\n\n  .impac_phiso_ho_pg_label {\n    font-size: 14px;\n  }\n}\n\n/* ---------- Reduced motion ---------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .impac_phiso_ho_pg_heading,\n  .impac_phiso_ho_pg_card,\n  .impac_phiso_ho_pg_stat,\n  .impac_phiso_ho_pg_bar {\n    transition: opacity 0.2s ease !important;\n    transition-delay: 0s !important;\n    transform: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
